<template>
	<Tooltip :trigger="['hover']" placement="bottom" :title="labelRef">
		<Upload
			:class="buttonClass"
			v-model:file-list="fileList"
			:show-upload-list="false"
			:max-count="1"
			name="file"
			:data="data"
			:action="actionRef"
			:headers="headers"
			@change="handleUpload"
		>
			<Button class="width-100" :type="buttonType" :loading="isUploading" :disabled="disabled ||isUploading">
				<UploadOutlined /> <span v-if="alwaysShowLabel || smallScreen">{{ labelRef }}</span>
			</Button>
		</Upload>
	</Tooltip>
</template>

<script>
import { ref, toRef } from 'vue';

import { Tooltip, Upload, Button } from 'ant-design-vue';
import { UploadOutlined } from '@ant-design/icons-vue';

import { useSmallScreen } from '@/utils/useSmallScreen';

import { showErrorMessage } from '@/components/common/errorMessage';

import Api from '@/api/Api';

export default {
	components: {
		Tooltip, Upload, Button, UploadOutlined,
	},
	props: {
		action: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			default: '',
		},
		onSuccess: {
			type: Function,
			default() {
				return;
			},
		},
		onError: {
			type: Function,
			default(errors) {
				showErrorMessage(errors);
			},
		},
		buttonClass: {
			type: String,
			default: '',
		},
		buttonType: {
			type: String,
			default: 'default',
		},
		alwaysShowLabel: {
			type: Boolean,
			default: false,
		},
		data: {
			type: Object,
			default: () => ({}),
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const fileList = ref([]);
		const { actionURL, headers } = Api.getUploadData(props.action);
		const isUploading = ref(false);

		const labelRef = toRef(props, 'label');
		const { smallScreen } = useSmallScreen();

		const handleUpload = info => {
			isUploading.value = true;
			if (info.file.status === 'done') {
				isUploading.value = false;
				const response = info.file.response;
				if (response.status === 'errors') {
					props.onError(response.errors);
				} else {
					props.onSuccess(response);
				}
			} else if (info.file.status === 'error') {
				isUploading.value = false;
				props.onError('uploadError');
			}
		};
		return {
			labelRef,
			fileList,
			isUploading,
			actionRef: ref(actionURL),
			headers: ref(headers),
			smallScreen,
			handleUpload,
		}
	},
}
</script>
